import { FormControl, InputLabel, Select, FormHelperText, SelectProps, FormHelperTextProps } from '@mui/material';

interface OwnProps {
    className?: string;
    helperText?: string;
    FormHelperTextProps?: FormHelperTextProps;
}

const StyledSelectField: FC<Omit<SelectProps, 'variant'> & OwnProps> = ({
    children,
    className,
    fullWidth,
    helperText,
    margin,
    FormHelperTextProps: passedFormHelperProps = {},
    style = {},
    SelectDisplayProps: { style: selectStyle, ...SelectDisplayProps } = {},
    error,
    ...rest
}) => {
    const { label } = rest;

    return (
        <FormControl
            variant="outlined"
            aria-describedby="name-helper-text"
            className={className}
            fullWidth={fullWidth}
            error={error}
            margin={margin ?? 'normal'}
        >
            <InputLabel>{label}</InputLabel>
            <Select
                {...rest}
                style={style}
                // Use min-width from root style
                SelectDisplayProps={{
                    style: {
                        minWidth: style.minWidth ?? '150px',
                        ...selectStyle,
                    },
                    ...SelectDisplayProps,
                }}
            >
                {children}
            </Select>
            {helperText ? <FormHelperText {...passedFormHelperProps}>{helperText}</FormHelperText> : null}
        </FormControl>
    );
};

export default StyledSelectField;
